import Vapi from 'vuex-rest-api';

const fetcherAdminProfile = new Vapi({
  state: {
    fetcherAdminProfile: {
      id: 0,
    },
  },
})
  .get({
    action: 'getFetcherAdminProfile',
    property: 'fetcherAdminProfile',
    path: ({ cid }) => `/api/fetcher/admin/profiles/${cid}`,
  })
  .getStore();

export default fetcherAdminProfile;
